export default {
	back_to_top: 'トップへ戻る',
	banner_btn: {
		buy_now: '今すぐ購入',
		learn_more: '詳細を見る',
	},
	banner_list: [
		{
			title: '安全・安定 · 優れたコストパフォーマンス · グローバルネットワークの物理サーバー',
			subtitle: '専用物理サーバー',
			desc: '専有ハードウェア、高性能でカスタマイズ可能、強力な分離によるセキュリティで、多様な業務シーンに企業級の演算力を提供<br />ビジネスの安定運用と継続的な成長を支援',
		},
		{
			title: 'NVMe 超高速 I/O · 次世代高性能 VPS',
			subtitle: 'NVMe クラウドサーバー',
			desc: '最新世代の Intel Xeon プロセッサ搭載、ハードウェアの購入や保守に手間をかける必要はありません<br />購入即開通、すぐに利用、アプリを高速デプロイ',
		},
	],
	data_center: {
		desc: 'アジア、北米、欧州など主要データセンターを網羅し、複数の Tier 1 国際キャリアと直接接続。TB 級の中国キャリア 3C 専用線リソース、CN2/GIA に対応。',
		list: [
			{ key: 'hk', name: '香港' },
			{ key: 'us', name: 'アメリカ' },
			{ key: 'jp', name: '日本' },
			{ key: 'kr', name: '韓国' },
			{ key: 'my', name: 'マレーシア' },
			{ key: 'sg', name: 'シンガポール' },
			{ key: 'au', name: 'オーストラリア' },
		],
		title: 'データセンターの所在地',
	},
	product: {
		desc: '次世代クラウドアーキテクチャに基づくコストパフォーマンスに優れた VPS — より速く、より安定し、より柔軟なパフォーマンスを提供 \n プロジェクトを総合的に加速',
		specialties: [
			{
				title: 'ビジュアル管理プラットフォーム',
				desc: 'クラウドサーバーを管理するスマートコントロールセンターを提供。電源 ON/OFF、パスワードリセット、OS 再インストールなどを実行可能',
			},
			{
				title: '更なる高速性',
				desc: '純粋な U.2 NVMe アーキテクチャ、単一ディスク最大 8000G、IOPS/ディスク最大 641,800、スループット/ディスク最大 3200MBps、レイテンシ 11µs まで低減',
			},
			{
				title: 'グローバル多回線',
				desc: '中国電信・モバイル・聯通、PCCW、HKBN、NTT、Cogent、Level3、Lumen などに接続し、ユーザー独自の VPC で安全に分離',
			},
		],
		title: 'NVMe 超高速 I/O · 次世代高性能 VPS',
	},
	products: {
		desc: 'VPS ホスティングや専用サーバーレンタルなど、多様なサーバー製品を提供し、お客様の様々なニーズにお応えします',
		list: [
			{
				title: 'VPS ホスティング',
				desc: '高速・安定・高弾性の演算サービス。NVMe アーキテクチャ採用でクラウドから手軽に取得・開通でき、お客様のワークロードを実現',
			},
			{
				title: 'サーバーレンタル',
				desc: '高仕様ハードウェアにより安定性と高性能を確保。プラットフォーム全自動化、ワンクリックで再起動・再インストールが可能で、コアビジネスの急成長を支援',
			},
		],
		title: '多様なサーバー製品',
	},
	stats: {
		data_centers: 'データセンター',
		support: 'カスタマーサポート',
		uptime: '稼働率',
		virtualization: '仮想化',
	},
	testimonials: {
		desc: 'お客様からのご意見・ご提案を一つひとつ大切に収集しています。',
		title: 'お客様の声',
	},
	testimonials_list: [
		{ quote: '弾性クラウドでリソースを自由に設定でき、無駄な費用がなくなり、さらにロイヤルティ特典で長く使うほどお得です。', name: 'Jerry Liu' },
		{ quote: 'リソースを自動監視し、悪質な利用者を制御。ネットワーク接続は快適で、ディスクも常に良好。オススメです。', name: 'ファン' },
		{ quote: '強力なカスタムパネルでオンライン操作が一瞬で完了、価格も手頃で性能も優秀。クラウドサーバー選びに最適です。', name: '夢' },
	],
	why: {
		desc: '2012 年に仮想ホスティング、2014 年にクラウドサーバーを開始、2019 年に新ブランドを設立しました。全てのクラウドサーバー製品は成熟した KVM 仮想化技術を採用し、自社開発の使いやすい中国語対応コントロールパネルと組み合わせ、高可用な自主管理が可能な成熟したクラウドサーバー製品をお届けします。',
		list: [
			{
				title: 'リソース不足が心配?',
				desc: '事業を始めたばかりなのに IP が足りないと言われた、繁忙期に帯域が追いつかない、サーバー移行で大損失',
				solution: '解決策: 数百万 IP ＋ TB 級帯域、サイトファーム IP は月額 80 ドルから',
				case: '1 台から 1000 台まで、全てお任せください',
			},
			{
				title: 'トラブル時に対応してもらえるか心配?',
				desc: '深夜にサーバーがダウンしたのに英語メールを送れと言われる、技術的な内容が伝わらず手間がかかる、誰にも連絡が取れず焦るばかり',
				solution: '解決策: 24 時間 365 日日本語対応、重大障害は 15 分以内に応答',
				case: '母国語でのコミュニケーション、ストレスゼロのサポート',
			},
			{
				title: '技術的な敷居が高いのが心配?',
				desc: 'サーバーを購入しても環境構築が分からない、WordPress 一つ入れるのに何時間もかかる、Linux コマンドより本業に集中したい',
				solution: '解決策: ワンクリック展開、3 分でアプリ稼働',
				case: '比較: 従来は数時間 → 当社なら 3〜5 分',
			},
		],
		title: '当社が選ばれる理由',
	},
}
